var __jsx = React.createElement;
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { Wrapper } from './styles';
import { MediaContext } from '@spa/shared/contexts/media';
import { showModalAction } from '@spa/shared/store/actions/modal';
import SimpleCarousel from '@spa/shared/components/SimpleCarousel';
import { redirect } from '@spa/shared/utils/redirect';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import { cityCodeToCitySlug } from '@spa/shared/utils/cityCodeToCitySlug';
import { addToWishlistAction, removeFromWishlistAction } from '@spa/shared/store/actions/profile';
import Recommendation from '@spa/shared/components/Recommendation';
var MoreListings = function MoreListings(_ref) {
  var title = _ref.title,
    cityCode = _ref.cityCode,
    recommendations = _ref.recommendations,
    showTrustedTag = _ref.showTrustedTag,
    _ref$disableWishlist = _ref.disableWishlist,
    disableWishlist = _ref$disableWishlist === void 0 ? true : _ref$disableWishlist,
    isLoggedIn = _ref.isLoggedIn,
    cardWidth = _ref.cardWidth,
    cardGap = _ref.cardGap,
    wishlist = _ref.wishlist,
    showWishlistModal = _ref.showWishlistModal,
    addToWishlist = _ref.addToWishlist,
    removeFromWishlist = _ref.removeFromWishlist,
    trackListing = _ref.trackListing;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useContext = useContext(MediaContext),
    is = _useContext.is;
  var handleOfferClick = function handleOfferClick(e, href) {
    e.preventDefault();
    e.stopPropagation();
    trackListing();
    redirect()(href, is.notMobile);
  };
  var handleWishlistClick = function handleWishlistClick(e, id) {
    var _wishlist$cities;
    e.preventDefault();
    e.stopPropagation();
    if (!isLoggedIn) {
      showWishlistModal();
      return;
    }
    var city = cityCodeToCitySlug(cityCode);
    var isOnWishlist = wishlist === null || wishlist === void 0 ? void 0 : (_wishlist$cities = wishlist.cities) === null || _wishlist$cities === void 0 ? void 0 : _wishlist$cities.items.some(function (_ref2) {
      var accommodation_offer_ids = _ref2.accommodation_offer_ids;
      return accommodation_offer_ids.includes(+id);
    });
    isOnWishlist ? removeFromWishlist({
      offerId: +id,
      city: city
    }) : addToWishlist({
      offerId: +id,
      city: city
    });
  };
  return __jsx(Wrapper, null, __jsx(SimpleCarousel, {
    title: title,
    numberOfElements: recommendations === null || recommendations === void 0 ? void 0 : recommendations.data.length,
    itemWidth: cardWidth,
    gap: cardGap
  }, recommendations === null || recommendations === void 0 ? void 0 : recommendations.data.map(function (recommendation) {
    return __jsx("div", {
      key: title
    }, __jsx(Recommendation, {
      recommendation: recommendation,
      cityCode: cityCode,
      wishlist: wishlist,
      isMobile: is.mobile,
      language: language,
      t: t,
      handleOfferClick: handleOfferClick,
      handleWishlistClick: handleWishlistClick,
      disableWishlist: disableWishlist,
      showTrustedTag: showTrustedTag
    }));
  })));
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var cityCode = _ref3.offer.offerAggregate.property_aggregate.property.location.address.city_code,
    _ref3$profile = _ref3.profile,
    isLoggedIn = _ref3$profile.isLoggedIn,
    wishlist = _ref3$profile.wish_list;
  return {
    cityCode: cityCode,
    isLoggedIn: isLoggedIn,
    wishlist: wishlist,
    isWishlistLoading: wishlist === null || wishlist === void 0 ? void 0 : wishlist.isLoading
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showWishlistModal: function showWishlistModal() {
      return dispatch(showModalAction({
        modalId: modalIds.WISHLIST
      }));
    },
    addToWishlist: function addToWishlist(_ref4) {
      var offerId = _ref4.offerId,
        city = _ref4.city;
      return dispatch(addToWishlistAction({
        offerId: offerId,
        city: city
      }));
    },
    removeFromWishlist: function removeFromWishlist(_ref5) {
      var offerId = _ref5.offerId,
        city = _ref5.city;
      return dispatch(removeFromWishlistAction({
        offerId: offerId,
        city: city
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MoreListings);